export default function FuxIcon({ className = "", color = "currentColor" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120.46 174.53"
      className={className}
      aria-hidden="true"
    >
      <path d="M7.06,0c.93,1.5,3.47,1.96,4.79,2.62,3.51,1.74,7.02,4.15,10.46,5.23l2.18,2.18L.09,34V3.05L2.7,0h4.36Z" fill={color}/>
      <path d="M68.95,0l2.62,3.05c-.08,9.3.11,18.6,0,27.9-.01.89.43,2.73-.44,3.05l-23.97-23.97,2.18-2.18c3.84-1.29,7.68-4.03,11.33-5.23l3.92-2.62h4.36Z" fill={color}/>
      <path d="M33.65,15.69c1.13-.31,3.05.21,4.36,0l33.56,33.56v4.36l-34.43,33.56c-1.88.41-2.88-.52-4.36-.87L.96,54.49c-.64-1.66-1.17-3.16-.87-5.23L33.65,15.69Z" fill={color}/>
      <path d="M53.7,86.3c.52-.15,1.17.11,1.74,0l38.79,38.79c-.5.94.78,1.34.87,1.74.43,1.86-.54,2.89-.87,4.36l-42.28,42.28c-.94-.5-1.34.78-1.74.87-3.24.73-4.56-.84-6.54-3.05v-75.84c.77-.64,1.4-1.59,2.18-2.18.19-.14.7.14.87,0,1.48-1.17,6.17-6.74,6.97-6.97Z" fill={color}/>
      <path d="M33.21,96.77v46.2L3.57,113.76c-.87-1.93-1.06-3.73-.87-6.1l17.87-17.87c2.56-.73,4.91,3.86,6.97,5.23.19.12.64-.14.87,0,1.58.94,2.81,2.17,4.79,1.74Z" fill={color}/>
      <path d="M102.95,121.17c-.08-.08.09-.94-.87-2.18-1.78-2.29-11.9-11.1-12.2-12.2v-27.02c1.75-2.03,3.81-3.38,6.54-3.05l23.97,23.97c-.15,1.1.22,2.5,0,3.49-.07.31-.7.49-.87.87-.12.27.11.68,0,.87-.99,1.66-12.41,12.88-14.38,14.38-.53.4-1.57,1.48-2.18.87Z" fill={color}/>
    </svg>
  );
}
